import React, { ReactNode, memo, useState } from 'react';

import ThemeProvider from '@plasma/ui.themes.theme-provider';
import { ThemeOverride } from '@plasma/ui.utils.types';

//import CustomModal from '../product-detail/product-detail.styles'
import useProductDetailHook from './product-detail.hook';
import * as styled from './product-detail.styles';
import themes from './themes';


import SimpleList from '@plasma/ui.display.simple-list';

import Modal from '@plasma/ui.layout.modal';
import OverflowMenu from '@plasma/ui.navigation.overflow-menu';
import PopConfirm from '@plasma/ui.feedback.pop-confirm';

import Button from '@plasma/ui.general.button';

import Switch from '@plasma/ui.input.switch';

import TopBarThemed from '../../components/top-bar-themed';
import { AddProfileButton, CardListContainer, CardSubtitle, CardTitle,
  FormContainer, FormLabel, FormRow, ListContainerDiv, ListContainerItem, MenuContentArea,
  ModalContainer, PopConfirmContainer, ProfileContainer, ProfileDetailsContainer, SelectContainer,
  SwitchContainer, SwitchLabel, StyledCard, StyledFormSelect,
  ProfileAndSelectContainer,
  StyledFormInput} from './product-detail.styles';


const { Option } = StyledFormSelect;

export interface ProductDetailProps {
  children?: ReactNode;
  /**
   * Defines custom className
   */
  className?: string;
  /**
   * Defines component's custom style
   */
  style?: React.CSSProperties;
  // add new properties here...
}

type Props = ProductDetailProps & ThemeOverride;

function ProductDetail(props: Props) {
  const { children, className, style, size, themeMode } = props;
  const superUserRole= sessionStorage.getItem('superUserRole');

  const {
          t,
          finalDataToShowInCard,
          modalTitle,
          ModalVisible,
          profile,
          dataToLoadInEditMode,
          productType,
          productCode,
          productDescription,
          isActive,
          remarksInModal,
          isFormVisible,
          roleID,
          handleSaveFromModal,
          handleDeleteFromModal,
          handleSetBoolean,
          handleEdit,
          HandleModalCancel,
          handleProfileChange,
          handleVisibilityModal,
          handleproductTypeChange,
          handleproductCodeChange,
          handleproductDescriptionChange,
          handleSwitchChange,
          handleremarksChange
        } = useProductDetailHook(props);

  const ItemComponent = ({ productdescription }) => {
    const [isMaxHeightSet, setIsMaxHeightSet] = useState(true);
    const handleMaxHeightToggle = () => {
      setIsMaxHeightSet(!isMaxHeightSet);
    };

    return (
      <div onClick={handleMaxHeightToggle}>
        <ListContainerDiv maxHeight={isMaxHeightSet}>

          <SimpleList
            dataSource={productdescription}
            renderItem={(item) => (
              <ListContainerItem >{item.productcode} : {item.productdescription}</ListContainerItem>
            )}
          />

        </ListContainerDiv>
      </div>
    );

  };


  return (
    <ThemeProvider themes={themes} selectedSize={size} selectedMode={themeMode}>
      <styled.ProductDetail className={`product-detail ${className ?? ''}`.trim()} style={style}>

      <TopBarThemed topHeading={t("profile-detail")}/>

      { superUserRole && <AddProfileButton title={t("add-profile")} onClick={()=>handleVisibilityModal() } />}

      <Modal
          title={modalTitle}
          width={'max-content'}
          okText={ `${t("save")} ${t("profile")}`}
          cancelText={t("cancel")}
          visible={ModalVisible}
          onCancel={() => HandleModalCancel()}
          onOk={() => handleSaveFromModal()}
          confirmLoading= {(productType.trim() === '' || productType.trim().length === 0 || productCode.trim()=== '' || productCode.trim().length=== 0 || productDescription.trim()=== '' || productDescription.trim().length=== 0) ? true : false}
          destroyOnClose={true}
        >

        <ModalContainer>

            {isFormVisible && (
              <SwitchContainer isActive={isActive}>
                <SwitchLabel isActive={isActive}>
                  {t("active")} ? :
                </SwitchLabel>
                <Switch
                  size='small'
                  checked={isActive}
                  onChange={handleSwitchChange}
                />
            </SwitchContainer>
            )}

            <ProfileContainer>
              {dataToLoadInEditMode && dataToLoadInEditMode.profileDetail && (
                <ProfileAndSelectContainer>

                  <ProfileDetailsContainer>
                    {t("profile")} :
                  </ProfileDetailsContainer>

                  <SelectContainer>
                    <StyledFormSelect
                      dropdownStyle={{ minWidth: '300px' }}
                      placeholder={`${t("select")} ${t("profile")}`}
                      onChange={handleProfileChange}
                      value={profile}
                    >
                      {dataToLoadInEditMode?.profileDetail?.map((item, index) => (
                        <StyledFormSelect.Option key={index} value={item.productcode}>
                          {item.productcode} : {item.productdescription}
                        </StyledFormSelect.Option>
                      ))}
                    </StyledFormSelect>

                    <PopConfirmContainer>
                    {profile && (

                        <PopConfirm
                          title={<div>{t("delete-confirmation-text")} ?</div>}
                          onConfirm={handleDeleteFromModal}
                          okText="Delete"
                          cancelText="Cancel"

                        >
                          <Button
                            title={t("delete")}
                            type="danger"
                            prefixIcon={{ name: 'delete_outline' }}
                            style={{marginLeft: '7vw'}}
                          />
                        </PopConfirm>

                    )}
                    </PopConfirmContainer>

                  </SelectContainer>

                </ProfileAndSelectContainer>
              )}
            </ProfileContainer>

              {isFormVisible && (
                <FormContainer>
                  <FormRow marginTop="10px">
                    <FormLabel>{`${t("product")} ${t("type")}`}</FormLabel>
                    <StyledFormInput
                      placeholder={`${t("product")} ${t("type")}*`}
                      value={productType}
                      onChange={handleproductTypeChange}
                      disabled={profile ? true : false}
                    />
                  </FormRow>

                  {!profile && (
                    <FormRow>
                      <FormLabel>{`${t("product")} :`}</FormLabel>
                      <StyledFormInput
                        placeholder={`${t("product")} ${t("name")}*`}
                        value={productCode}
                        onChange={handleproductCodeChange}
                        disabled={profile ? true : false}
                      />
                    </FormRow>
                  )}

                  <FormRow>
                    <FormLabel>{`${t("dimension")}`}</FormLabel>
                    <StyledFormInput
                      placeholder="Product Dimension*"
                      value={productDescription}
                      onChange={handleproductDescriptionChange}
                    />
                  </FormRow>

                  <FormRow>
                    <FormLabel>{`${t("remarks")}`}</FormLabel>
                    <StyledFormInput
                      placeholder="Remarks (Optional)"
                      value={remarksInModal}
                      onChange={handleremarksChange}
                    />
                  </FormRow>
                </FormContainer>
              )}


        </ModalContainer>
      </Modal>

      <CardListContainer>
        {finalDataToShowInCard?.map((oneItem, index: number) => (

            <StyledCard isHovered={oneItem.isHovered} key={index}
              cardClassType="creationCard"
              metaCardClassType="metaCreationCard"
              onMouseEnter={() => handleSetBoolean(index, true)}
              onMouseLeave={() => handleSetBoolean(index, false)}
              border
              shadow={true}
              meta={{
                title: (
                  <CardTitle isHovered={oneItem.isHovered}>
                    <b>{oneItem.producttype}</b>
                  </CardTitle>
                ),
                subtitle: <CardSubtitle>{`${t("all")} ${t("profile")}`}</CardSubtitle>,
                menuContentArea: (
                  <MenuContentArea isHovered={oneItem.isHovered}>
                    {superUserRole ? (
                      <OverflowMenu
                        items={[
                          {
                            label: t("edit"),
                            key: 'edit',
                            icon: 'ModeEditOutlineOutlined',
                            onClick: (e) => handleEdit(oneItem, e),
                          },
                        ]}
                      />
                    ) : null}
                  </MenuContentArea>
                ),
              }}
            >
              <ItemComponent
                key={index}
                productdescription={oneItem.profileDetail?.map((oneProfile) => oneProfile)}
              />
            </StyledCard>

        ))}
      </CardListContainer>

      </styled.ProductDetail>
    </ThemeProvider>
  );
}

export default memo(ProductDetail) as unknown as typeof ProductDetail;
